import ValueListManagerView from "../presentation/views/ValueListManagerView.vue";
import ValueListDetailView from "../presentation/views/ValueListDetailView.vue";
export const valueListRoutes = [
    {
        path: "/module/value-lists",
        name: "ValueListManager",
        component: ValueListManagerView,
        meta: {
            requiresAuth: true,
            requiresCapability: "accessmanager.manage-users",
            titleKey: "valueLists.title",
        },
    },
    {
        path: "/module/value-lists/:code",
        name: "ValueListDetail",
        component: ValueListDetailView,
        meta: {
            requiresAuth: true,
            requiresCapability: "accessmanager.manage-users",
            titleKey: "valueLists.title",
        },
    },
];
